import React from 'react';
import withAppStore, { WithAppStoreProps } from 'utils/withAppStore';

interface Props extends WithAppStoreProps {
  id: string;
  onClicked?: (projectId: string) => void;
  label: string;
  count: number;
  doesChangeColor: boolean;
}

const ItemCount: React.FC<Props> = (props: Props) => {
  const { id, onClicked, label, count, doesChangeColor, appState } = props;
  const { selectedProject } = appState;
  const fontColor = doesChangeColor && count > 0 ? '#de3428' : '#4b575d';

  return (
    <div
      id={id}
      className="column w100 bgd-white b-radius-3 shadow"
      style={{ height: '140px' }}
      // onClick={(): void => {
      //   onClicked(selectedProject);
      // }}
    >
      <div
        id={`${id}-count-link`}
        // onClick={(): void => {
        //   onClicked(selectedProject);
        // }}
        className="ml4"
        style={{
          color: fontColor,
          fontSize: '48px',
          textDecoration: 'none',
        }}
      >
        <div className="mt4 mb4 font-size-5">{label}</div>
        <div
          className="bold"
          style={{
            color: fontColor,
            fontSize: '48px',
          }}
        >
          {`${count}`}
        </div>
      </div>
    </div>
  );
};

export default withAppStore<Props>(ItemCount);
